// @flow

import * as React from 'react';

import clsx from 'clsx';

import type { TranslatorProps } from '@gandi/translate';
import { Checkbox, Alert, Base } from '@gandi/ui';

import {
  ErrorMessage,
  Fieldset,
  Form,
  FormField,
  type FieldProps,
} from 'gandi.react-form';

import styles from './ClaimsForm.scss';

export type FormData = {
  claim: boolean,
};

export type ClaimsFormProps = {
  ...TranslatorProps,
  error?: string,
  handleSubmit?: () => Promise<any>,
  submitFailed?: boolean,
};

export default class ClaimsForm extends React.Component<ClaimsFormProps> {
  static FORM_ID: string = 'claims-form';

  renderField: (props: FieldProps<any>) => React.Node = props => {
    const { __ } = this.props;
    const showError =
      !!props.meta.error && (props.meta.touched || this.props.submitFailed);
    const label = __(
      'I acknowledge to have seen that the above trademarks are registered.',
    );
    const checked = props.input.value;
    return (
      <Fieldset error={showError}>
        <Checkbox {...props.input} checked={checked}>
          {label}
        </Checkbox>
        {showError && <ErrorMessage text={props.meta.error} />}
      </Fieldset>
    );
  };

  render(): React.Node {
    const { __ } = this.props;
    const formClass = clsx('form-stacked', styles.root);

    return (
      <Form
        id={ClaimsForm.FORM_ID}
        method="post"
        onSubmit={this.props.handleSubmit}
        className={formClass}
        noValidate
      >
        {this.props.error && (
          <Base marginBottom="base">
            <Alert
              intent="danger"
              title={__('Error')}
              // $FlowFixMe error is checked on surrounding bloc
              message={this.props.error}
            />
          </Base>
        )}

        <FormField name="claim" component={this.renderField} />
      </Form>
    );
  }
}
